import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { SscFileItem } from '../models/ssc-file-item.model';

export interface SscFileUploadAdapter {
  readonly storageUrl: string;
  upload(file: File): Observable<SscFileItem>;
}

export const SSC_FILE_UPLOAD_ADAPTER = new InjectionToken<SscFileUploadAdapter>(
  'SSC_FILE_UPLOAD_ADAPTER',
);
